export default {
  heroEyebrow: 'Pricing',
  heroTitle: 'Start with one process and scale from there',
  heroBody:
    'Free and Team are for self-serve adoption. Enterprise supports organization-wide implementation, scale and deployment requirements.',

  billingYearly: 'Yearly',
  billingYearlySave: 'save 13%',
  billingMonthly: 'Monthly',

  tierBusinessName: 'Business',
  tierBusinessAudience: 'Free to evaluate',
  tierBusinessCta: 'Start for free',
  tierBusinessFeature1: 'Configurable digital employees',
  tierBusinessFeature2: 'Scheduled runs and result history',
  tierBusinessFeature3:
    'Jira, Confluence, GitHub, documents, mail and calendars',
  tierBusinessFeature4: 'Answers backed by source links',
  tierBusinessFeature5: 'Permissions inherited from connected systems',
  tierBusinessFeature6: 'Cloud delivery and email support',

  planFreeName: 'Free',
  planFreeSeats: '14 days · 1 user',
  planFreePrice: '0 ₽',
  planTeamName: 'Team',
  planTeamSeats: 'per user / month',
  planTeamPriceMonthly: '2,300 ₽',
  planTeamPriceYearly: '1,990 ₽',

  tierEnterpriseName: 'Enterprise',
  tierEnterpriseAudience: 'For AI teams and organization-wide scale',
  tierEnterpriseCta: 'Request a demo',
  tierEnterprisePlusLabel: 'Enterprise includes:',
  tierEnterpriseFeature1: 'Cloud, Hybrid or On-Premises',
  tierEnterpriseFeature2: 'Custom plugins and integrations',
  tierEnterpriseFeature3:
    'Corporate domain verification as an alternative to SSO',
  tierEnterpriseFeature4: 'Action logs and governance',
  tierEnterpriseFeature5: 'Expansion across departments and workflows',
  tierEnterpriseFeature6: 'Dedicated guidance at every stage and SLA',

  deliveryEyebrow: 'Deployment options',
  deliveryTitle: 'Choose the right environment',
  deliveryBody:
    'Laplace is available in Cloud, Hybrid and On-Premises configurations. Architecture, data access and responsibilities are agreed before launch.',
  deliveryCloudTitle: 'Cloud',
  deliveryCloudBody:
    'A managed service with fast onboarding and updates. Corporate domain verification is available as an alternative to SSO.',
  deliveryOnPremTitle: 'On-Premises',
  deliveryOnPremBody:
    'Laplace deployed in the customer’s infrastructure for a closed corporate environment.',
  deliveryHybridTitle: 'Hybrid',
  deliveryHybridBody:
    'Cloud Laplace with a Private Connector: Jira, Confluence and GitHub access stays inside the customer network.',

  matrixTitle: 'What’s included in each plan',
  matrixColFeatures: 'Capabilities',
  matrixYes: 'Included',
  matrixNo: 'Not available',
  matrixRowUsers: 'Users',
  matrixRowUsersBusiness: 'Free — 1, Team — up to 20',
  matrixRowUsersEnterprise: 'custom',
  matrixRowWorkspaces: 'Workspaces',
  matrixRowWorkspacesBusiness: 'Free — 3, Team — unlimited',
  matrixRowWorkspacesEnterprise: 'custom',
  matrixRowIntegrations: 'Integrations',
  matrixRowIntegrationsBusiness: 'standard',
  matrixRowIntegrationsEnterprise: 'standard + custom',
  matrixRowCloud: 'Cloud',
  matrixRowOnPrem: 'On-Premises',
  matrixRowHybrid: 'Hybrid',
  matrixRowCorporateDomain: 'Corporate domain verification',
  matrixRowAudit: 'Context Audit',
  matrixRowSupport: 'Support',
  matrixRowSupportBusiness: 'email',
  matrixRowSupportEnterprise: 'guided support + SLA',
  matrixFootnote:
    'Cloud and Hybrid are available for every plan. On-Premises is delivered as part of Enterprise with an agreed architecture.',

  ctaTitle: 'We’ll match the format to your first process',
  ctaBody:
    'In the demo, we’ll review the workflow, deployment needs and success criteria, then propose the right Laplace configuration.',
  ctaButton: 'Request a demo',
}
